import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RevenueStreamEnum } from '../enums/revenue-stream-enum';

@Injectable()
export class AppConstants {
  public applicationId = 'SalesWeb';
  public APPLICATION_NAME = 'SALESTOOLS';
  public baseUrl = environment.apiUrl;
  public dmcApplicationUrl = environment.dmcApplicationUrl;
  public serviceBaseUrl = environment.serviceUrl;
  public ERP_API_KEY = environment.erpApiKey;
  public ERP_API = `${this.serviceBaseUrl}/erp/api/v1`;
  // ERP OData $batch endpoint for contracting roles.
  public ERP_BATCH_ODATA_URL = `${environment.erpODataUrl}/api/v1/odata/$batch`;
  public SIGNIN = `${this.baseUrl}/techfoundation/api/v1/login/ValidateUser`;
  public API_BASE_URL_BIDS = `${environment.bidApi}`;
  public API_BASE_URL_JOB_SELECTION = `${environment.jobSelectionApi}/v1`;
  public API_BASE_URL_USER = `${environment.userApi}/v1`;
  public API_BASE_URL_JOB = `${environment.jobApi}/v1`;
  public BUSINESSDATA_BASE_URL = `${environment.businessDataApi}/v1`;
  public API_BASE_URL_SALESWEBGATEWAY = `${environment.salesWebGatewayApi}/v1`;
  public API_BASE_URL_WORKPACKAGE = `${environment.workPackageApi}/v1`;
  public API_BASE_URL_DOCUMENTPACKAGE = `${environment.documentPackageApi}/v1`;
  public API_BASE_URL_CREDIT_JOBS = `${environment.orderApi}/v1`;
  public API_BASE_URL_ORDER_HISTORY = `${environment.orderHistoryApi}/v1`;
  public API_BASE_URL_ORDER = `${environment.orderingApi}/v1`;
  public API_BASE_URL_ORDERGATEWAY = `${environment.orderGatewayApi}/v1`;
  public API_BASE_URL_SHIPPING_HISTORY = `${environment.manufacturingOrderMaintenanceApi}/v1`;
  public API_BASE_URL_CAMGATEWAY = `${environment.camGatewayApi}/v1`;
  public API_BASE_URL_DOCUMENT = `${environment.documentApi}/v1`;
  public API_BASE_URL_DIRECT_JOB = `${environment.jobDirectApi}/v1`;
  public ACCESS_DENIED = 'This user does not have permission to access this application,<br>' +
    ' please contact your application support team for assistance.';
  public AUTHORIZE_ACCESS_DENIED = 'This user is unauthorized to access this application,<br>' +
    ' please contact your application support team for assistance.';
  public TRANE_CRM_COMPANY_URL = `${environment.crmCompanyUrl}`;
  public TRANE_CRM_OPPY_URL = `${environment.crmOppyUrl}`;
  public REQUIRED_FIELD_MESSAGE = 'Field is required';
  public CREATE_COST_CONTAINER_WARNING_MESSAGE = `There is unsaved data on the page.<br/> Do you want to go back without saving?`;
  public PO_ADDENDUM_WARNING_MESSAGE = `There is unsaved data on the page.<br/> Do you want to leave without saving?`;
  public JOB_DETAILS_VALIDATION_ERROR_MESSAGE = 'Please enter all the highlighted fields';
  public JOB_DETAILS_DOCUMENTS_EXIT_CONFIRMATION_MESSAGE = 'The selected file and notes will no longer be available to ' +
    'upload and save. Do you want to proceed?';
  public IMPORT_JOB_EXIT_CONFIRMATION_MESSAGE = 'The selected file and data entered will no longer be available for import. ' +
    'Do you want to proceed?';
  public TOOLTIP_MESSAGE_ON_DISABLED_TABS = 'Sales orders cannot be accessed when Risk Flag is Preliminary or Detailed.';
  public TOOLTIP_MESSAGE_ON_DISABLED_TABS_FOR_EQUIPMENT = 'Sales orders cannot be accessed when Risk Flag is Preliminary.';
  public NOTIFICATION_TEXT = 'You have new notifications';
  public SUPPORT_DATABASE_DR_ADDRESS_ID = 142;
  public PLANNED_SHIPMENT_COLUMNS = [
    {
      columnName: 'P/S',
      class: 'col w-grid-80',
    },
    {
      columnName: 'R12 SO',
      class: 'col',
    },
    {
      columnName: 'Ordr. Stat.',
      class: 'col',
    },
    {
      columnName: 'ROJ Date',
      class: 'col',
    },
    {
      columnName: 'Mfg. Stat.',
      class: 'col',
    },
    {
      columnName: 'Shipping Address Name',
      class: 'col',
    },
    {
      columnName: 'Trane Installed',
      class: 'col',
    },
    {
      columnName: 'Partial Ship OK',
      class: 'col',
    },
    {
      columnName: 'Req. Dlv. Win.',
      class: 'col',
    },
    {
      columnName: 'Est. Shp. Date',
      class: 'col',
    },
    {
      columnName: 'ESD Causal Code',
      class: 'col',
    },
    {
      columnName: 'Lead Time Rls Date',
      class: 'col',
    },
    {
      columnName: 'Commit Date',
      class: 'col',
    },
    {
      columnName: 'Shp. Date',
      class: 'col',
    },
    {
      columnName: '',
      class: 'col w-grid-40',
    },
  ];
  public PROJECT_HEADER_COLUMNS = [
    {
      columnName: 'Job Name',
      class: 'w-1/12 jobName',
    },
    {
      columnName: 'Project Nbr.',
      class: 'w-1/12 projectNbr',
    },
    {
      columnName: 'Project Name',
      class: 'w-1/6 projectName',
    },
    {
      columnName: 'Job Contact',
      class: 'w-1/12 jobContact',
    },
    {
      columnName: 'Equipment Project Manager',
      class: 'w-1/6 equipmentProjectManager',
    },
    {
      columnName: 'Lead Project Manager',
      class: 'w-1/6 leadProjectManager',
    },
    {
      columnName: 'Area Contracting Manager',
      class: 'w-1/6 areaContractingManager',
    },
    {
      columnName: 'Project Administrator',
      class: 'w-1/6 projectAdministrator',
    },
    {
      columnName: 'Customer Name',
      class: 'w-1/6 customerName',
    },
    {
      columnName: 'Date',
      class: 'w-1/12',
    },
    {
      columnName: 'Archive Date',
      class: 'w-1/12',
    },
  ];
  public SHIPPING_HISTORY_HEADER_COLUMNS = [
    {
      columnName: 'Serial Number',
      class: 'col-1 serialNumber',
    },
    {
      columnName: 'Order Number',
      class: 'col-1 orderName',
    },
    {
      columnName: 'BOM',
      class: 'col-1',
    },
    {
      columnName: 'Mfg Location',
      class: 'col-2 buMfgLocation',
    },
    {
      columnName: 'Job Name',
      class: 'col-1 jobName',
    },
    {
      columnName: 'Ship Date',
      class: 'col-1 shipDate',
    },
    {
      columnName: 'Ship To',
      class: 'col-1 shipTo',
    },
    {
      columnName: 'Model Number',
      class: 'col-2 modelNum',
    },
    {
      columnName: 'File Name',
      class: 'col-1 fileName',
    }
  ];
  public TRANSMIT_BALANCE_INFO = `There has been changes to the project that has caused it to be out of balance with R12 Financials. The date is the last date it was in balance. Please review Price Summary and transmit changes.`;
  public No_JOBS_CRITERIA = 'No jobs meet criteria.';
  public SALESPERSON = 'Sales Person';
  public JOBCONTACT = 'Job Contact';
  public SALES_ORDERS_NO_DATA_MESSAGE = 'No sales order(s) available';
  public TRANE = 'Trane';
  public SHOW_FILTERS = 'Show Filters';
  public HIDE_FILTERS = 'Hide Filters';
  public SEARCH_CATEGORY_ALL = RevenueStreamEnum.All;
  public SEARCH_CATEGORY_EQUIPMENT = RevenueStreamEnum.Equipment;
  public SEARCH_CATEGORY_CONTRACTING = RevenueStreamEnum.Contracting;
  // EntityType + Name pairs for the ERP job-project `Roles` used to resolve contracting columns.
  public JOB_PROJECT_ROLE_ENTITY = {
    equipment: 'equipment',
    creditProject: 'credit-project',
  };
  public JOB_PROJECT_ROLE_NAME = {
    projectManager: 'project-manager',
    areaContractingManager: 'area-contracting-manager',
    projectAdministrator: 'project-administrator',
  };
  // OData `job-projects` filter field: Transmitted/History use `erpProjectNumber`, Untransmitted uses `number`.
  public JOB_PROJECT_ODATA_FILTER_FIELD = {
    erpProjectNumber: 'erpProjectNumber',
    number: 'number',
  };
  public readonly PT4_JOB_CODE_ID = 607;
  // These class codes are corresponding to Transistional Job, Vertical Market, BOD on Equipments, BOD on Controls respectively.
  // since these class codes are already available in genral section, we are excluding from classification.
  public EXPORT_TO_EXCEL_ERROR_TOASTER = 'Error occured while exporting to file';
  public TransmittedCopiedDownDisplayMode = 'TransmittedCopiedDown';
  public ShippingHistoryDisplayMode = 'Shipping History';
  public SHIPPING_HISTORY_DOWNLOAD_REQUEST = 'Your download request has been accepted. You will receive a notification shortly on the request status';
  public DOWNLOAD_ERROR_MESSAGE = 'Error occured while downloading file';
  public PREVALIDATION_START_MESSAGE = 'System is running prevalidation rules in the background';
  public PREVALIDATION_SUCCESS_MESSAGE = 'System has completed running prevalidation rules. Please review Errors/Warnings panel';
  public PREVALIDATION_ERROR_MESSAGE = 'System could not complete prevalidation check due to network/connectivity issue. Please check your connection status and try again';
  public REBALANCE_VALIDATION_START_MESSAGE = 'System is running rebalance validation rules in the background.';
  public REBALANCE_VALIDATION_SUCCESS_MESSAGE = 'System has completed running rebalance validation rules. Please review Errors/Warnings panel.';
  public REBALANCE_VALIDATION_ERROR_MESSAGE = 'System could not complete rebalance validations due to network/connectivity issue. Please check your connection status and try again.';
  public readonly TRANSLATION_LANGUAGE = 'en';
  public PREVALIDATION_EVENT = 'PreValidation';
  public COORDINATION_EARTHWISE_MESSAGE = 'Systems from Trane section in the Job Details page is required prior to Coordination being allowed. No System is a valid selection.';
  public COORDINATION_CLASSIFICATION_MESSAGE = 'All fields in the Classification section of the Job Details page need to have a value other than None selected.';
  public KEY_TEAM_MEMBERS_SAVE_SUCCESS_MESSAGE = 'Key Team Members section data has been saved';
  // Url for mendix margin pricing tool
  public MENDIX_MARGIN_PRICING_TOOL_BASE_URL = environment.mendixMarginPricingToolUrl;
  public readonly WORKFLOW_SUPPORT_NODE = 'Support';
  public readonly MANUAL_PAYMENT_NODE = 'Manual payment';
  public readonly WORKFLOW_NODE = 'Work Flows';

  // SharePoint
  public SHAREPOINT = 'SharePoint';

  // Work package preference
  public WORKPACKAGE_PREFERENCES_MENU_VIEW_ACCESS = 'HasWorkPackagePreferenceAccess';

  // Environment
  public readonly DEV_ENVIRONMENT = 'Development';
  public readonly UAT_ENVIRONMENT = 'UAT';
  public readonly STAGING_ENVIRONMENT = 'Staging';
  public readonly PROD_ENVIRONMENT = 'production';

  public PO_ADDENDUM_CANCELLED = 'Cancelled';

  // Users
  public SALES_ORDER_USER = 'S';

  // Roles
  public USER_ROLE = 'CTXDBSELECTOR';
  public USER_ROLE_TEST = 'CTXDBSELECTORTEST';

  // Current page state
  public PRICE_SUMMARY = 'PriceSummary';
  public REVIEW_REVENUE_FORECAST = 'ReviewRevenueForecast';

  public BID_XREF_CALL_INPROGRESS_MESSAGE = 'Bid and selection mapping save in progress. You will be redirected automatically after the save.';

  // Only show my requests
  public ONLY_SHOW_MY_REQUESTS = 'My Requests Only?';
  public ONLY_SHOW_MY_REQUESTS_STATUS = 'showMyRequestsChange';

  public DATE_FORMAT = 'MM/dd/yyyy';

  // These are the classes that are used for switching between job and product code searching on the jobs page
  public searchTypes = {
    jobsSearchType: 'Jobs',
    productFamilySearchType: 'Product Family',
  };

  public SEARCH_JOBS_THREE_YEARS = 'Searches may take longer when searching over three years';
  public SEARCH_JOBS_ONE_YEAR = 'Searches may take longer when searching over one year';
  public timeframes = {
    oneWeek: 'in the past week',
    oneMonth: 'in the past month',
    oneYear: 'in the past year',
    threeYears: 'in the past three years',
  };

  public STATUS_CODES = {
    NOT_FOUND: 404,
    NO_CONTENT: 204,
    FORBIDDEN: 403
  };

  // Time entry screen constants
  public TIME_ENTRY_VIEWS = { myTime: 'myTime', adminView: 'adminView', managerView: 'managerView', bosView: 'bosView' };
  public TIME_ENTRY_ROLES = {
    admin: 'TT-CHVAC-time-admin',
    user: 'TT-CHVAC-time-entry',
    manager: 'TT-CHVAC-time-manager',
    bosSupportUser: 'tsmt-bos-support'
  };
  public contractingRevenueStreamTypes = ['CONTROLS', 'ENERGY SERVICES', 'INDUSTRIAL REFRIGERATION'];

  public allMenusToDisable = ['Price', 'Coordinate', 'Price Summary', 'Sov', 'Billing', 'Assign Sales Orders', 'Documents'];
  public disabledJobMenusForDelegatedUser = ['Price', 'Coordinate', 'Documents'];
  public forecastRoute = 'forecasting-tool';
}
